import { Component } from 'san';

import {
    IUser,
    IAuthUser,
    IOrganization,
    IAuthOrganization
} from 'src/models';

import Pagination from '../Pagination/Pagination';

import authService from 'src/services/auth.service';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import checkOrganizationService from 'src/services/checkOrganization.service';

export default class Auth extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-pagination': Pagination,
    }

    initData(): {
        isShow: boolean,
        projectPuid: string,
        pageSize: number,
        userData: {
            users: IAuthUser[],
            count: number,
            page: number
        },
        organizationData: {
            organizations: IAuthOrganization[],
            count: number,
            page: number
        }
    } {
        return {
            isShow: false,
            projectPuid: '',
            pageSize: 10,
            userData: {
                users: [],
                count: 0,
                page: 1
            },
            organizationData: {
                organizations: [],
                count: 0,
                page: 1
            }
        };
    }

    inited() {
    }

    // 显示授权查看（外部调用）
    show(projectPuid: string) {
        this.data.set('isShow', true);
        this.data.set('projectPuid', projectPuid);
        this.getAuthUsers(1);
        this.getAuthOrganizations(1);
    }

    //#region 用户 
    getAuthUsers(page: number) {
        const params = {
            project_puid: this.data.get('projectPuid'),
            page: page,
            limit: this.data.get('pageSize')
        };
        authService.getAuthUsers(params).then(res => {
            const users = res.list;
            const count = res.total;
            const dataKey = 'userData.users';
            const oldUsers = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldUsers.length, ...users]);
            this.data.set('userData.count', count);
            this.data.set('userData.page', page);
        });
    }

    goToAuthUsersPage(params: { page: number; limit: number }) {
        this.getAuthUsers(params.page);
    }

    toAddAuthUsers() {
        checkOrgUsersService.show({
            isMultiple: true,
            callback: (users) => {
                this.addAuthUsers(users);
            }
        });
    }
    addAuthUsers(users: IUser[]) {
        const dataKey = 'userData.users';
        const authUsers = this.data.get(dataKey);
        const newAuthUserIds: string[] = [];
        _.forEach(users, user => {
            if (-1 === _.findIndex(authUsers, { user_id: user.user_id })) {
                newAuthUserIds.push(user.user_id);
            }
        });
        if (!newAuthUserIds.length) {
            return;
        }
        authService.addAuthUsers(this.data.get('projectPuid'), newAuthUserIds).then(() => {
            this.getAuthUsers(this.data.get('userData.page'));
        });
    }

    deleteAuthUser(authUser: IAuthUser) {
        authService.deleteAuthUser(this.data.get('projectPuid'), authUser.user_id).then(() => {
            this.getAuthUsers(this.data.get('userData.page'));
        });
    }
    //#endregion

    //#region 组织
    getAuthOrganizations(page: number) {
        const params = {
            project_puid: this.data.get('projectPuid'),
            page: page,
            limit: this.data.get('pageSize')
        };
        authService.getAuthOrganizations(params).then(res => {
            const organizations = res.list;
            const count = res.total;
            const dataKey = 'organizationData.organizations';
            const oldOrganizations = this.data.get(dataKey);
            this.data.splice(dataKey, [0, oldOrganizations.length, ...organizations]);
            this.data.set('organizationData.count', count);
            this.data.set('organizationData.page', page);
        });
    }

    goToAuthOrganizationsPage(params: { page: number; limit: number }) {
        this.getAuthOrganizations(params.page);
    }

    toAddAuthOrganization() {
        checkOrganizationService.show({
            callback: (organization) => {
                this.addAuthOrganization(organization);
            }
        });
    }
    addAuthOrganization(organization: IOrganization) {
        const dataKey = 'organizationData.organizations';
        const authOrganizations: IAuthOrganization[] = this.data.get(dataKey);
        if (!organization) {
            return;
        }
        if (-1 !== _.findIndex(authOrganizations, { organization_id: organization.org_number })) {
            return;
        }
        authService.addAuthOrganization(this.data.get('projectPuid'), organization.org_number).then(() => {
            this.getAuthOrganizations(this.data.get('organizationData.page'));
        });
    }

    deleteAuthOrganization(authOrganization: IAuthOrganization) {
        authService.deleteAuthOrganization(this.data.get('projectPuid'), authOrganization.organization_id).then(() => {
            this.getAuthOrganizations(this.data.get('organizationData.page'));
        });
    }
    //#endregion

    submit() {
        this.cancel();
    }

    cancel() {
        this.data.set('isShow', false);
    }
}